export function replaceAllButFirstOccurrence(
  value: string,
  regex: RegExp,
  replace: string,
): string {
  if (!value) {
    return value;
  }

  const firstIdx = value.search(regex);

  if (firstIdx < 0) {
    return value;
  }

  return value.replace(regex, (match, offset) => {
    return firstIdx === offset ? match : replace;
  });
}
